<template>
  <NavigationLayout
    :navigationTitle="$t('musicRights')"
    :navigationBarStyle="{
      'top': 'var(--safe-area-inset-top, 0px)',
    }"
    :navigationContentStyle="{
      'padding-top': 'calc(44px + var(--safe-area-inset-top, 0px))',
    }"
  >
    <div class="personal__wrapper" slot="contents">
      <section class="page__header">
        <i18n path="musicRightsDesc" tag="p">
          <template #br><br /></template>
          <template #jasracLink>
            <a href="http://www2.jasrac.or.jp/eJwid/">J-WID</a>
          </template>
          <template #nextoneLink>
            <a href="https://search.nex-tone.co.jp/">
              {{ $t('musicRightsNextoneDatabase') }}
            </a>
          </template>
        </i18n>
      </section>
      <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        class="musicRightsFormWrapper"
      >
        <div class="personal__container">
          <p class="formOperationText">
            {{ $t('maxSongsPerRequest', { maxFormCount: maxFormCount }) }}
          </p>
          <section class="personal__submit">
            <ButtonSubmit
              class="formOperationButton"
              title="+"
              v-bind:disabled="musicRightsApplyList.length >= maxFormCount"
              v-on:click.native="addForm"
            />
            <ButtonSubmit
              class="formOperationButton"
              title="−"
              v-bind:disabled="musicRightsApplyList.length <= minFormCount"
              v-on:click.native="deleteForm"
            />
          </section>
          <section
            v-for="(musicRightsApply, index) in musicRightsApplyList"
            :key="index"
          >
            <div class="formSection">
              <p class="formNoText">No.{{ index + 1 }}</p>
              <ValidationProvider
                rules="jasrac_code"
                :vid="`jasracId_no${index + 1}`"
                v-slot="{ errors }"
              >
                <div class="list_item__container">
                  <div class="list_item__content list_item__element">
                    <div class="list_item__title">
                      <label :for="`jasracId_no${index + 1}`">{{
                        $t('musicRightsJasracCode')
                      }}</label>
                    </div>
                  </div>
                  <div class="list_item__action list_item__element">
                    <input
                      :id="`jasracId_no${index + 1}`"
                      v-model="musicRightsApply.jasracId"
                      @input="setJasracIdWithoutHyphen(index)"
                      v-bind:style="{ minWidth: '200px' }"
                      type="text"
                      :placeholder="`${$t('musicRightsExample')}11111111`"
                      size="8"
                    />
                  </div>
                </div>
                <div class="error__messages">
                  <span v-for="(error, index) in errors" :key="index">
                    <p v-if="error !== undefined">{{ error }}</p>
                  </span>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="nextone_code"
                :vid="`nextoneId_no${index + 1}`"
                v-slot="{ errors }"
              >
                <div class="list_item__container">
                  <div class="list_item__content list_item__element">
                    <div class="list_item__title">
                      <label :for="`nextoneId_no${index + 1}`">{{
                        $t('musicRightsNextoneCode')
                      }}</label>
                    </div>
                  </div>
                  <div class="list_item__action list_item__element">
                    <input
                      :id="`nextoneId_no${index + 1}`"
                      v-model="musicRightsApply.nextoneId"
                      v-bind:style="{ minWidth: '200px' }"
                      type="text"
                      :placeholder="`${$t('musicRightsExample')}N11111111`"
                    />
                  </div>
                </div>
                <div class="error__messages">
                  <span v-for="(error, index) in errors" :key="index">
                    <p v-if="error !== undefined">{{ error }}</p>
                  </span>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|work_title_long"
                v-slot="{ errors }"
              >
                <div class="list_item__container">
                  <div class="list_item__content list_item__element">
                    <div
                      class="list_item__title"
                      v-bind:style="ListItemStyleSectionLast"
                    >
                      <label :for="`title_no${index + 1}`">{{
                        $t('musicRightsTitle')
                      }}</label>
                    </div>
                  </div>
                  <div class="list_item__action list_item__element">
                    <input
                      :id="`title_no${index + 1}`"
                      v-model="musicRightsApply.title"
                      v-bind:style="{ minWidth: '200px' }"
                      type="text"
                      :placeholder="`${$t('musicRightsPlaceholder')}`"
                      required
                    />
                  </div>
                </div>
                <div class="error__messages">
                  <span v-for="(error, index) in errors" :key="index">
                    <p v-if="error !== undefined">{{ error }}</p>
                  </span>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|artist_name_long"
                v-slot="{ errors }"
              >
                <div class="list_item__container">
                  <div class="list_item__content list_item__element">
                    <div
                      class="list_item__title"
                      v-bind:style="ListItemStyleSectionLast"
                    >
                      <label :for="`artistName_no${index + 1}`">{{
                        $t('musicRightsArtistName')
                      }}</label>
                    </div>
                  </div>
                  <div class="list_item__action list_item__element">
                    <input
                      :id="`artistName_no${index + 1}`"
                      v-model="musicRightsApply.artistName"
                      v-bind:style="{ minWidth: '200px' }"
                      type="text"
                      :placeholder="`${$t('musicRightsPlaceholder')}`"
                      required
                    />
                  </div>
                </div>
                <div class="error__messages">
                  <span v-for="(error, index) in errors" :key="index">
                    <p v-if="error !== undefined">{{ error }}</p>
                  </span>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|min_value:1|max_value:100"
                v-slot="{ errors }"
              >
                <div class="list_item__container">
                  <div class="list_item__content list_item__element">
                    <div
                      class="list_item__title"
                      v-bind:style="ListItemStyleSectionLast"
                    >
                      <label :for="`count_no${index + 1}`">{{
                        $t('musicRightsCount')
                      }}</label>
                    </div>
                  </div>
                  <div class="list_item__action list_item__element">
                    <input
                      :id="`count_no${index + 1}`"
                      v-model="musicRightsApply.count"
                      v-bind:style="{ minWidth: '100px' }"
                      type="number"
                      :placeholder="`${$t('musicRightsExample')}1`"
                      min="1"
                      max="99"
                      step="1"
                      required
                    />
                  </div>
                </div>
                <div class="error__messages">
                  <span v-for="(error, index) in errors" :key="index">
                    <p v-if="error !== undefined">{{ error }}</p>
                  </span>
                </div>
              </ValidationProvider>
            </div>
          </section>
        </div>
        <div class="submitBtn">
          <section class="personal__submit">
            <ButtonSubmit
              class="personal__submit_button"
              :title="$t('musicRightsSubmit')"
              v-bind:disabled="invalid"
              v-on:click.native="submit"
            />
          </section>
        </div>
      </ValidationObserver>
    </div>
  </NavigationLayout>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import { LanguageQueryHandler } from '@/mixins/LanguageQuery'
import ButtonSubmit from '@/components/ButtonSubmit.vue'
import NavigationLayout from '@/components/NavigationLayout.vue'
import MypageStyle from '@/styles/mypage'
import {
  ValidationObserver,
  ValidationProvider,
} from '../../../utils/validation'
import { api } from '@/api/appGatewayServerApi'
import { apiV2 } from '@/api/appGatewayServerV2Api'
import { MusicRightsApply } from '@/models/MusicRights'
import { handleUnauthorized } from '@/utils/handle_error'
import { checkInMaintenance } from '@/utils/maintenance'

@Component({
  components: {
    ButtonSubmit,
    NavigationLayout,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class MusicRights extends Mixins(LanguageQueryHandler) {
  ListItemStyleSectionLast = MypageStyle.ListItemSectionLast

  minFormCount = 1
  maxFormCount = 5

  jasracRules = ''
  nextoneRules = ''

  musicRightsApplyList: MusicRightsApply[] = []

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>
    inputElement: HTMLInputElement
  }

  async created() {
    try {
      // メンテナンスチェック
      await api().maintenance.allCheck()

      this.resetForm()
    } catch (e) {
      if (checkInMaintenance(e)) {
        // メンテの場合はそのままメンテ中画面へリダイレクト
        this.$router.push({ path: '/maintenance' }).catch(() => {})
        return
      }
      handleUnauthorized(e)
    }
  }

  resetForm() {
    // バリデーションエラーをリセット
    this.$refs.observer.reset()

    // デフォルト2曲分のフォームを用意
    this.musicRightsApplyList = [
      {
        jasracId: '',
        nextoneId: '',
        title: '',
        artistName: '',
        count: 1,
      },
      {
        jasracId: '',
        nextoneId: '',
        title: '',
        artistName: '',
        count: 1,
      },
    ]
  }

  addForm() {
    // 楽曲申請フォーム数が5以上の場合はエラーを表示して増やせないようにする
    if (this.musicRightsApplyList.length >= this.maxFormCount) {
      return
    }

    this.musicRightsApplyList.push({
      jasracId: '',
      nextoneId: '',
      title: '',
      artistName: '',
      count: 1,
    })
  }

  deleteForm() {
    // 楽曲申請フォーム数が1の場合はエラーを表示して減らせないようにする
    if (this.musicRightsApplyList.length <= this.minFormCount) {
      return
    }

    this.musicRightsApplyList.pop()
  }

  async submit() {
    // 送信前にバリデーションを行う
    const isVlid = this.$refs.observer.validate()
    if (!isVlid) {
      alert(this.$t('validationCommonErrorMessage'))
      return
    }

    // 送信前にフォームの内容をチェックして、全て空の項目があるフォームは削除して詰める
    this.musicRightsApplyList = this.musicRightsApplyList.filter(
      (musicRightsApply) => {
        return (
          musicRightsApply.jasracId !== '' ||
          musicRightsApply.nextoneId !== '' ||
          musicRightsApply.title !== '' ||
          musicRightsApply.artistName !== ''
        )
      }
    )

    if (this.musicRightsApplyList.length > this.maxFormCount) {
      // フォーム数がなぜかmaxFormCountを超えている場合はエラーを表示して送信を中止する
      alert(this.$t('errorGeneral'))
      return
    }

    // 送信前にcountに文字列が入っている場合は数値に変換する
    // また、jasracIdにハイフンが入っている場合は取り除く
    this.musicRightsApplyList = this.musicRightsApplyList.map(
      (musicRightsApply) => {
        return {
          ...musicRightsApply,
          count: parseInt(musicRightsApply.count.toString(), 10),
          jasracId: musicRightsApply.jasracId.replace(/[^0-9a-zA-Z]/g, ''),
        }
      }
    )

    // 送信前にjasracIdとnextoneIdのどちらかが空の場合はエラーを表示して送信を中止する
    // （この時indexも取得してアラート時に表示する）
    let codeErrorIndexList: number[] = []
    this.musicRightsApplyList.forEach((element) => {
      if (element.jasracId === '' && element.nextoneId === '') {
        codeErrorIndexList = [
          ...codeErrorIndexList,
          this.musicRightsApplyList.indexOf(element),
        ]
      }
    })

    if (codeErrorIndexList.length > 0) {
      let codeErrorMessage = ''
      codeErrorIndexList.forEach((index) => {
        codeErrorMessage += `No.${index + 1} `
      })
      alert(this.$t('inputValidationMessageMusicRightsCodeEmpty'))
      return
    }

    // 確認画面がないので代わりにここで最終確認を行う
    if (!confirm(this.$t('registrationConfirmation').toString())) {
      return
    }

    try {
      // 念のためメンテナンスチェック
      await api().maintenance.allCheck()
      // 登録処理
      await apiV2().musicRights.apply({
        musicRightsApplyList: this.musicRightsApplyList,
      })
      alert(this.$t('registrationCompleted'))
      this.resetForm()
    } catch (e) {
      alert(this.$t('errorGeneral'))
      if (checkInMaintenance(e)) {
        // メンテの場合はそのままメンテ中画面へリダイレクト
        this.$router.push({ path: '/maintenance' }).catch(() => {})
        return
      }
      handleUnauthorized(e)
    }

    return
  }

  setJasracIdWithoutHyphen(index: number) {
    const jasracID = this.musicRightsApplyList[index].jasracId
    // ハイフンつきコードを貼り付けた場合、ハイフンを取り除いた状態でセットする
    this.musicRightsApplyList[index].jasracId = jasracID.replace(
      /[^0-9a-zA-Z]/g,
      ''
    )
  }
}
</script>

<style scoped>
.page__header {
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 16px;
  font-size: 12px;
  text-align: left;
}

.personal__wrapper {
  position: relative;
  height: auto;
  min-height: 100%;
  background-color: #fafafa;
  padding-left: 24px;
  padding-right: 24px;

  @media (min-width: 800px) {
    width: 800px;
    margin: 0 auto;
    margin-bottom: 16px;
  }
}

.personal__container input {
  min-width: 144px;
  width: auto;
}

.personal__submit {
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  justify-content: right;
}
.personal__submit_button {
  width: 220px;
  height: 44px;
  display: table;
  margin-right: 20px;
  margin-bottom: 20px;
}

/* error messages */
.error__messages {
  padding: 0 16px;
  margin-bottom: 20px;
  font-family: sans-serif;
  font-size: 14px;
  color: #f73d59;
}

/** list item */
.list_item__container {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: #e8e8e8 solid 1px;
  border-collapse: collapse;
  background-color: #ffffff;
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
}

.list_item__container.list_item__container_warning {
  color: #f73d59;
  border: 1px #f73d59 solid;
}

.list_item__element {
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 12px;
  margin-bottom: 12px;
}

.list_item__content {
  align-self: start;
  padding-top: 0px;
  padding-left: 16px;
  padding-right: 16px;
}
.list_item__action {
  text-align: right;
  margin-right: 16px;
}

/* mypage */
input {
  font-size: 14px;
  color: #262626;
}

.musicRightsFormWrapper input {
  display: block;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.musicRightsFormWrapper input:focus {
  border-color: #66afe9;
  outline: none;
  box-shadow: 0 0 8px rgba(102, 175, 233, 0.6);
}

.formSection {
  border: #e8e8e8 solid 3px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.submitBtn {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 80px;
}

.formOperationText {
  font-size: 12px;
}

.formOperationButton {
  width: 32px;
  height: 32px;
  display: table;
  margin-left: 12px;
}

.formNoText {
  font-size: 14px;
  font-weight: bold;
  margin: 10px;
}
</style>
